import { arSA as ar, enGB as en } from 'date-fns/locale'
import { format } from 'date-fns'
import { DEFAULT_DATE_MASK, DEFAULT_DATE_MASK_AR } from '@/shared/constants/masks.constants'
import type { Locale } from '@/shared/types/common.types'

export const capitalize = (str: string) => str.charAt(0).toUpperCase() + str.slice(1)

export const parseDateFromStr = (str: string) => {
  const [day, month, year] = str.split('/')
  return new Date(+year, +month - 1, +day)
}

export const toFixedNumber = (value: number, fixed = 2): number => {
  const factor = Math.pow(10, fixed)
  return Math.round(value * factor) / factor
}

export function formatDate(value: Date, locale: Locale, mask?: string) {
  let formatString = locale === 'ar' ? 'd MMMM yyyy' : 'dd/MM/yyyy'
  if (mask) {
    formatString = mask
  }
  const formatLocale = locale === 'ar' ? ar : en
  const marker = locale === 'ar' ? '\u200f' : ''
  return value ? format(value, `${marker}${formatString}`, { locale: formatLocale }) : ''
}

export function formatDateDefault(value: Date | string | null, locale: Locale) {
  if (!value) return ''
  return formatDate(
    new Date(value),
    locale,
    locale === 'ar' ? DEFAULT_DATE_MASK_AR : DEFAULT_DATE_MASK
  )
}

export const decreaseYears = (date: Date, years: number) => {
  const newDate = new Date(date)
  newDate.setFullYear(date?.getFullYear() - years)
  return newDate
}

export const increaseYears = (date: Date, years: number) => {
  const newDate = new Date(date)
  newDate.setFullYear(date?.getFullYear() + years)
  return newDate
}

export const getDateWithoutTime = (date: Date) =>
  new Date(date.getFullYear(), date.getMonth(), date.getDate())
